import Cookies from "js-cookie";
import { USER_REVENUECAT_ID } from "../../constants/global";

export const getUserRevenueCatId = (): string | undefined =>
  Cookies.get(USER_REVENUECAT_ID);
